export const SERVICE_LIST_DATA = [
  { label: 'amministrazione' },
  { label: 'elaborazione' },
  { label: 'consulenti' },
  { label: 'businessConsumer' },
  { label: 'businessBusiness' },
  { label: 'eventi' },
  { label: 'corsi' },
  { label: 'archivio' },
  { label: 'assistenza' },
  { label: 'costante' },
];
